module.exports = __webpack_public_path__ + "static/jazzass-60192fa08261dfacf6f5e1f19e276b05.jpg";